import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_SG',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: true,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  'c2e17542-5597-44ea-a8cc-ba642b74147c',
  ''
);
